import { fetchEventPage, type EventPage } from './fetchEventPage'
import type { ListTeamEventsQuery } from './listTeamEvents'

/**
 * ONE page of the events for one team in one season — the slice a team calendar
 * shows.
 *
 * Takes the same query as the team-wide variant — the window and sort the games
 * request is using — so a season-scoped stream and an All Seasons one are
 * bounded identically. See `ListTeamEventsQuery` for why a paged stream must be
 * server-sorted rather than sorted on arrival.
 *
 * Errors throw, like every other event service.
 */
export const listRosterEventsPage = (
  teamId: string,
  rosterId: string,
  query: ListTeamEventsQuery = {},
  page = 1
): Promise<EventPage> =>
  fetchEventPage(`/teams/${teamId}/rosters/${rosterId}/events`, query, page)
